import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  uploadBlueprintSideSectionPaper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0px',
    alignItems: 'center',
    gap: '40px',
    width: '100%',
    paddingBottom: '96.5px',
    '@media (min-width: 640px)': {
      paddingBottom: 0,
    },
    '@media (min-width: 1024px)': {
      width: '33%',
    },
  },
  blueprintIconStyle: {
    width: '120px',
    height: '120px',
    '@media (min-width: 640px)': {
      margin: '0',
      width: 'auto',
    },
  },
  uploadBlueprintContainer: {
    backgroundColor: theme.evPalette.charcoal[100],
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '@media (min-width: 640px)': {
      padding: '24px 80px',
    },
  },
  uploadBlueprintEstimatedTotal: {
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)',
    backgroundColor: 'white',
    zIndex: 201,
    position: 'fixed',
    bottom: 0,
    '@media (min-width: 640px)': {
      position: 'static',
    },
  },
}));
